import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { Endpoint, HelpIndex, MessageType, UpdateStatusType } from '../../../models/enums';
import { Corpus } from '../../../models/corpus';
import { isArray } from '../../../models/utils';

@Component({
    standalone: false,
    selector: 'res-copy-to-doc-storage-modal',
    templateUrl: './copy-to-doc-storage-modal.component.html',
    styleUrls: ['./copy-to-doc-storage-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CopyToDocStorageModalComponent extends BaseModalComponent implements OnInit {
    isBusy = false;
    isBusyMessage: string;
    exclusions: any;
    corpus: Corpus;
    modalClass = 'copy-to-doc-storage-modal';
    modalAutomationId = 'copy-doc-storage';
    modalHelpIndex = HelpIndex.copy_to_doc_storage_options_dlg;

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private commonService: CommonService,
        private restService: RestService
    ) {
        super(modalService, modalRef);
    }

    ngOnInit() {
        this.exclusions = {};
        if (this.modalData instanceof Corpus) {
            this.corpus = this.modalData as Corpus;
            this.getAllIndexSettings();
        }
    }

    getAllIndexSettings() {
        this.isBusyMessage = 'Loading Settings...';
        this.isBusy = true;
        this.restService.post(Endpoint.projectManager_getIndexSettings, { handle: this.commonService.currentProject.handle }).then(response => {
            this.isBusy = false;
            if (response && response.settings && isArray(response.settings.copyToDocStorageExclusions)) {
                response.settings.copyToDocStorageExclusions.forEach(element => {
                    this.exclusions[element] = true;
                });
            }
        }, error => {
            this.isBusy = false;
        });
    }

    copyToDocStorage() {
        const allExclusions = [];
        for (const key in this.exclusions) {
            if (Object.prototype.hasOwnProperty.call(this.exclusions, key)) {
                if (this.exclusions[key] === true) {
                    allExclusions.push(key);
                }
            }
        }

        this.isBusyMessage = 'Copying to Document Storage...';
        this.isBusy = true;
        this.restService.post(Endpoint.corpusManager_copyToDocStorage, {
            viewHandle: this.corpus.corpusViewHandle, exclusions: allExclusions
        }).then(response => {
            this.isBusy = false;
            if (response) {
                this.commonService.sendMessage(MessageType.entityChanged, UpdateStatusType.CORPUS);
            }
        }, error => {
            this.isBusy = false;
        });
        this.closeModal();
    }
}
